import store from '@/store'
import liff from '@line/liff'
import { MasterService, DeliveryService, ShopService, CartService } from '@/services'
import { MASTER_DATA_KEY, COOKIE_ACCESS_TOKEN, PROVIDER } from '@/constants'
import Cookies from 'js-cookie'
import { ENV_KEY } from '@/constants/env'

export const getAuth = async () => {
  let provider
  if (Cookies.get(COOKIE_ACCESS_TOKEN)) {
    provider = { provider: PROVIDER.CUSTOMER }
  } else {
    provider =
      store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID) && liff.isLoggedIn()
        ? { provider: PROVIDER.LINE }
        : { provider: PROVIDER.CUSTOMER }
  }

  await store.dispatch('auth/getAuth', provider)
}

export const getMasterData = async () => {
  const { data } = await MasterService.getTargetDetail(MASTER_DATA_KEY)
  store.commit('master/SET_DATA', data)
}

export const getFee = async () => {
  const [{ data: freeData }, { data: shippingData }] = await Promise.all([
    ShopService.getShopInfo(store.getters['env/GET_KEY'](ENV_KEY.SHOP_ID)),
    DeliveryService.deliveryMethod(),
  ])

  store.commit('auth/SET_SHOP', freeData)
  store.commit('cart/SET_FREE_AMOUNT', Number(freeData.delivery_free_amount))
  store.commit('cart/SET_SHIPPING_FEE', shippingData[0].flat_rate_delivery_fee)
  store.commit('cart/SET_DELIVERY_ID', shippingData[0].id)
  store.commit('auth/SET_SHOP_NAME', freeData.shop_name)
}

export const getCartAbandonmentSetting = async () => {
  const { data } = await CartService.getCartAbandonmentSetting()
  store.commit('cartTracking/SET_CART_ABANDONMENT_SETTING', data)
}

export const checkLineLink = (path) => {
  if (!/^\/user.*/.test(path)) return true

  return !!Cookies.get(COOKIE_ACCESS_TOKEN)
}
